<template>
    <div class="project-container">
        <div class="project-content" ref="container" :style="styleObject">
            <div class="body">
                <div class="head">
                    <div class="head-title">地下停车场接送点</div>
                    <!--<div class="school">锦绣小学</div>-->
                    <div class="nowTime">
                        <span style="padding: 0 10px">{{week}}</span>
                        {{nowTime}}</div>
                </div>
                <div class="box">
                    <div class="box-l">
                        <div class="box-title">当前接送车辆清单</div>
                        <div class="box-c">
                            <div class="pageNumber">
                                <div :class="showPage==1?'pageN activePageF':'notPageF pageN'" @click="pageClick(0)">
                                    第1页
                                </div>
                                <div :class="showPage==(idx+1)?'pageN activePage':'notPage pageN'" v-for="(item,idx) in pageSize" :key="idx" @click="pageClick(idx)" v-if="idx>0">
                                    第{{item}}页
                                </div>
                            </div>
                            <div class="content">
                                <div class="content1 ">
                                    <div class="column" v-for="(item,idx) in showColumn" :key="idx">
                                        <div class="table-head">
                                            <div>车牌号</div>
                                            <div v-if="showCount==1||showCount==3">车位号</div>
                                            <div>入场时间</div>
                                            <div v-if="showCount==2||showCount==3">学生姓名</div>
                                        </div>
                                        <div class="table-box">
                                            <div v-for="(item,index) in groupedItems[idx+(showPage-1)*showColumn]"
                                                 :key="index">
                                                <div>{{item.plateNumber}}</div>
                                                <div v-if="showCount==1||showCount==3"></div>
                                                <div>{{item.time}}</div>
                                                <div v-if="showCount==2||showCount==3" class="name">{{item.studentName}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="content2">
                                    <div @click="carPre">上一页</div>
                                    <div @click="carNext">下一页</div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="box-r" v-if="showList==1">
                        <div class="box-title box-title1">新入场接送车辆清单</div>
                        <div class="box-cr">
                            <div class="content1">
                                <div class="column">
                                    <div class="table-head">
                                        <div>车牌号</div>
                                        <div>入场时间</div>
                                        <div v-if="showCount==2||showCount==3">学生姓名</div>
                                    </div>
                                    <div class="table-box">
                                        <div v-for="(item,index) in newGroupItems[newShowPage-1]" :key="index"
                                             class="fs24">
                                            <div>{{item.plateNumber}}</div>
                                            <div>{{item.newTime}}</div>
                                            <div v-if="showCount==2||showCount==3" class="name">{{item.studentName}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content2">
                                <div @click="newCarPre()">上一页</div>
                                <div @click="newCarNext()">下一页</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bigScreenCar",
        data() {
            return {
                schoolId: '',
                currentScale: '',
                containerHeight: '',
                styleObject: {},

                week:'',
                nowTime: '',
                query: {
                    schoolId: '',
                    openid: 'abc',
                },
                screenDatas: {},
                todayRepast: {},
                monthData: {},
                first: {},
                menuPlanDetails: [],

                canteensActive: {},

                showList: 1, //新入场清单 显示隐藏
                showCount: 3, //显示内容
                refreshDistance:10, //刷新间隔
                groupSize: 12,
                showColumn: 2, // 显示列
                pageSize: 1, //页数
                showPage: 1, //当前页
                newShowPage: 1, //新入场当前页
                thickData: [],
                groupedItems: [],
                datas: [],

                newThickData: [],
                newGroupItems: [],


            }
        },
        created() {
            this.schoolId = this.$route.query.schoolId
            this.getCarSettings()
            this.nowTimes()

        },
        mounted() {

            const baseWidth = 1920; // 设计稿宽度
            const viewportWidth = Math.min(
                document.documentElement.clientWidth,
                window.innerWidth || 0
            );
            // 计算缩放比例
            this.currentScale = (viewportWidth / baseWidth).toFixed(4);

            this.styleObject = {
                transform: `scale(${this.currentScale})`
            }

        },

        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = year + "-" + month + "-" + date + ' ' + hh + ":" + mm + ':' + ss

                let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                this.week=weeks[timeStamp.getDay()]
            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()

            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },

            getCarSettings() {
                let _this = this
                let url = '/zuhu1/api-dashboard/car/qCarSettings_2/v4'
                let query = {
                    schoolId: this.schoolId
                }
                this.$api.post(url, query, function (result) {
                    let datas = result.data.data || {}
                    let bigScreenSettings = datas.bigScreenSettings || {}
                    _this.showColumn = bigScreenSettings.showColumn || 2
                    _this.showList = bigScreenSettings.showList || 1
                    _this.showCount = bigScreenSettings.showCount || 3
                    _this.refreshDistance = bigScreenSettings.refreshDistance || 10

                    _this.getRecord()
                    setInterval(_this.timingRecord, _this.refreshDistance*1000);



                })
            },
            timingRecord(){
                let _this=this
                _this.getRecord()
                _this.carNext()

            },
            getRecord() {
                let _this = this
                let url = '/zuhu1/api-dashboard/car/q_inParkRecords'
                let query = {}
                this.$api.post(url, query, function (result) {
                    let datas = result.data.data || []
                    datas.sort((a, b) => new Date(b.InParkTime) - new Date(a.InParkTime))

                    let newArr = []
                    let now = new Date();
                    now.setMinutes(now.getMinutes() - 10);
                    let nowStr = now.getTime()

                    datas.map(item => {
                        item.time = item.InParkTime.substring(5, 16)
                        item.newTime = item.InParkTime.substring(11, 16)

                        if (new Date(item.InParkTime).getTime() > nowStr) {
                            newArr.push(item)
                        }
                    })
                    _this.thickData = datas
                    _this.groupItems()

                    _this.newThickData = newArr
                    _this.newGroupItem()
                })
            },

            // 数组分组
            groupItems() {
                let groupSize = this.groupSize
                this.groupedItems = [];
                for (let i = 0; i < this.thickData.length; i += groupSize) {
                    this.groupedItems.push(this.thickData.slice(i, i + groupSize));
                }
                this.pageSize = Math.ceil(this.groupedItems.length / this.showColumn)
            },
            newGroupItem() {
                let groupSize = this.groupSize
                this.newGroupItems = [];
                for (let i = 0; i < this.newThickData.length; i += groupSize) {
                    this.newGroupItems.push(this.newThickData.slice(i, i + groupSize));
                }
            },
            pageClick(idx) {
                this.showPage = idx + 1
                this.$forceUpdate()
            },

            newCarPre() {
                let length = this.newGroupItems.length
                if (this.newShowPage == 1) {
                    this.newShowPage = length
                } else {
                    this.newShowPage--
                }
            },
            newCarNext() {
                let length = this.newGroupItems.length
                if (this.newShowPage == length) {
                    this.newShowPage = 1
                } else {
                    this.newShowPage++
                }
            },

            carPre() {
                let length = this.pageSize
                if (this.showPage <= 1) {
                    this.showPage = length
                } else {
                    this.showPage--
                }
            },
            carNext() {
                let length = this.pageSize
                if (this.showPage >= length) {
                    this.showPage = 1
                } else {
                    this.showPage++
                }
            }

        }
    }
</script>

<style scoped>
    .project-container {
        position: relative;
        width: 100%;
        padding-top: 56.25%; /* 16:9 比例魔法数字 */
        overflow: hidden;
    }

    .project-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 1920px; /* 设计稿基准宽度 */
        height: 1080px; /* 设计稿基准高度 */
        transform-origin: top left;
        backface-visibility: hidden; /* 优化渲染性能 */
    }

    .body {
        width: 100%;
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
        background: url("../../assets/imgs/bigScreenCar/bj1.jpg") no-repeat center 0;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/bigScreenCar/top.png") no-repeat center 0;
        box-sizing: border-box;
    }

    .head-title {
        background: -webkit-linear-gradient(#4AF3F3, #179DF5);
        -webkit-background-clip: text;
        color: transparent;
        font-weight: bold;
    }

    .school {
        color: #69E7EE;
        position: absolute;
        left: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }

    .nowTime {
        color: #69E7EE;
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }

    .box {
        color: white;
        display: flex;
        padding: 0 20px;
        margin-top: -23px;
        height: calc(100% - 100px);
    }

    .box-l {
        flex: 2;
    }

    .box-r {
        flex: 1;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .box-title {
        font-size: 20px;
        padding: 0 0 10px 0;
    }

    .box-title1 {
        padding: 0 20px 10px !important;
    }

    .box-c {
        display: flex;
        height: calc(100% - 40px);
    }

    .pageNumber {
        overflow-x:hidden ;
        overflow-y: auto;
    }
    .pageNumber::-webkit-scrollbar {
        width: 4px;
    }

    .pageNumber::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .pageNumber::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }

    .pageNumber > div {
        writing-mode: vertical-rl;
        text-orientation: upright;
    }

    .pageNumber > div:first-child{
        margin-top: 0 !important;
        height: 110px !important;
    }

    .notPageF{
        background: url("../../assets/imgs/bigScreenCar/img_031.png") no-repeat center 0;
    }
    .activePageF{
        background: url("../../assets/imgs/bigScreenCar/img_03.png") no-repeat center 0 !important;
    }

    .notPage{
        background: url("../../assets/imgs/bigScreenCar/img_05.png") no-repeat center 0;
    }
    .activePage{
        background: url("../../assets/imgs/bigScreenCar/img_051.png") no-repeat center 0 !important;
    }

    .pageN {
        width: 50px;
        height: 145px;
        display: flex;
        align-items: center;
        justify-content: center;
        /*background: url("../../assets/imgs/bigScreenCar/img_05.png") no-repeat center 0;*/
        margin-top: -10px;
    }


    .content {
        padding: 20px;
        flex: 1;
        background: url("../../assets/imgs/bigScreenCar/image_01.png") no-repeat center;
        background-size: 100% 100%;
    }

    .content1 {
        display: flex;
        height: calc(100% - 74px);
    }

    .column {
        flex: 1;
        padding: 0 10px;
    }

    .table-head {
        display: flex;
        justify-content: space-between;
    }

    .table-head > div {
        min-width: 90px;
        text-align: center;
        display: inline-block;
        color: #36E5D6;
        border: 1px solid #0F99AA;
        border-radius: 5px;
        font-weight: bold;
        padding: 10px;
        margin-bottom: 10px;
    }

    .table-box {
        color: white;
    }

    .table-box > div {
        display: flex;
        background: #093C71;
        justify-content: space-between;
    }

    .table-box > div:nth-child(odd) {
        background: #0F224C;
    }

    .table-box > div > div {
        /*flex: 1;*/
        padding: 19px 0;
        min-width: 120px;
        text-align: center;
        font-size: 20px;
    }

    .content2 {
        display: flex;
        justify-content: center;
        padding: 20px 0;
    }

    .content2 > div {
        border: 1px solid #1E456F;
        border-radius: 4px;
        padding: 5px 20px;
        /*color: #A09FA3;*/
        color: #67CDE9;
        margin: 0 10px;
    }

    .box-cr {
        background: url("../../assets/imgs/bigScreenCar/image_03.png") no-repeat center;
        padding: 20px;
        flex: 1;
        background-size: 100% 100%;
        box-sizing: border-box;
        height: calc(100% - 40px);
    }

    .fs24 > div {
        font-size: 22px !important;
        padding: 18px 0 !important;
    }
    .name{
        color: #36E5D6;
    }
</style>


